import React from "react"

// Components
import StyledCard from "../../Global/StyledCard/StyledCard"

// Styles
import styles from "./collaboration.module.sass"

// Icons
import TimeIcon from "../../../icons/servicesPage/collaboration/time-and-material.svg"
import FixPriceIcon from "../../../icons/servicesPage/collaboration/fix-price.svg"
import DedicatedTeamsIcon from "../../../icons/servicesPage/collaboration/dedicated-teams.svg"

// Content
const collaborationArr = [
  {
    id: 1,
    title: `Fix price`,
    description: `This model works perfectly for short-term projects. Looking to get a hassle-free, time-saving result and not having much time to delve into specifications? Let's estimate the project and follow your business idea.`,
    icon: <FixPriceIcon />,
  },
  {
    id: 0,
    title: `Time and material`,
    description: `Time & Material model is used for long-term projects that have no clear plan and specifications. You are able to adjust the project’s requirements and shape to constantly changing business circumstances.`,
    icon: <TimeIcon />,
  },
  {
    id: 2,
    title: `Dedicated teams`,
    description: `This model is applied to long-term projects. The scope of work is not finished or new features are being added every now and then? Let‘s leverage a dedicated Development Team to speed up the project and reduce costs.`,
    icon: <DedicatedTeamsIcon />,
  },
]

const CollaborationScreen = () => {
  return (
    <section className={"section"}>
      <div className="container">
        <div className="row v-center space-between flex-wrap">
          <div className={"heading" + " " + styles.heading}>
            <h2>Collaboration Models</h2>
            <p>
              An example of the cryptocurrency payment system gateway we
              developed
            </p>
          </div>
          <div className={styles.wrapper}>
            {collaborationArr.map((col, index) => (
              <div className={styles.card} key={col.id}>
                <StyledCard type="reverse">
                  <div
                    className={
                      styles.content + " " + (index === 1 ? styles.center : "")
                    }
                  >
                    <div className={styles.icon}>{col.icon}</div>
                    <h3>{col.title}</h3>
                    <p>{col.description}</p>
                  </div>
                </StyledCard>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CollaborationScreen
